import React from 'react'
import Modal from '../../modals/confirmation'
import FiveStar from './five-star'
import { Form } from 'react-bootstrap'

const ConsentForm = ({
    title,
    description,
    children,
    onConfirm = () => {},
    confirmLabel = 'Submit',
    onCancel = () => {},
    cancelLabel = 'Snooze',
    rating = 0,
    onRatingChange = () => {},
    feedback,
    onFeedbackChange = () => {},
}) => {
    return (
        <Modal
            onConfirm={() => onConfirm()}
            onCancel={() => onCancel()}
            visible={true}
            title={title}
            confirmLabel={confirmLabel}
            cancelLabel={cancelLabel}
            disableConfirm={!rating}
        >
            {description}
            {children}
            <FiveStar value={rating} onChange={onRatingChange} />
            <Form.Group>
                <Form.Control as="textarea" rows={3}  placeholder="Give some feedback (optional)" value={feedback} onChange={e => onFeedbackChange(e.target.value)}/>
            </Form.Group>
            
        </Modal>
    )
}

export default ConsentForm
